import React, { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import parseExcel from 'common/utils/parse-excel';
import { Modal, Row, Col } from 'grab-ui';
import SpreadSheetUploader from 'components/v2/spreadsheet/spreadsheet-uploader';
import { getUploadSpreadsheetDataArea } from 'helper/bulk-upload';
import { BULK_UPLOAD_PARSING_ERRORS } from 'constants/booking-constants';
import { trackClick, event, cat, custom } from 'common/utils/instrumentation';
import { getCompanyID } from 'helper/user';
import {
  scribeTrackEvent,
  getCommonFacet,
  SCRIBE_STATE_NAMES,
  SCRIBE_BULK_UPLOAD_MODAL_EVENTS,
} from 'applications/scribe/instrumentations/track';

import css from './upload-spreadsheet-modal.less';

export const UPLOAD_SPREADSHEET_MODAL_ID = 'UPLOAD_SPREADSHEET_MODAL';

class UploadSpreadSheetModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pickingExcel: false,
      hoverOnModal: false,
    };
  }

  onClickModal = () => {
    this.setState({
      hoverOnModal: true,
    });
  };

  onUploadExcel = async file => {
    const { userInfo } = this.props;
    trackClick(event.BULK_UPLOAD_CLICKS, cat.GE_BULK_UPLOAD, 'UPLOAD_CSV', {
      [custom.COMPANY_ID]: getCompanyID(userInfo),
    });
    scribeTrackEvent({
      stateName: SCRIBE_STATE_NAMES.EXPRESS_BULK_UPLOAD_WEB,
      eventName: SCRIBE_BULK_UPLOAD_MODAL_EVENTS.UPLOAD_CSV,
      facets: getCommonFacet(userInfo),
    });

    const { processBulkUploadData } = this.props;
    try {
      parseExcel(
        file,
        {
          sheetName: 'Sheet1',
          dataArea: getUploadSpreadsheetDataArea(),
        },
        (cityID, rawDeliveries, serviceTypesInExcelStr) => {
          processBulkUploadData({
            cityIDInExcel: cityID,
            rawDeliveries,
            serviceTypesInExcelStr,
          });
        },
      );
    } catch (e) {
      processBulkUploadData({ parseError: BULK_UPLOAD_PARSING_ERRORS.failed });
    }
  };

  handleFocusBack = () => {
    const theFile = document.querySelectorAll('input[type=file]');
    if (theFile[0].files.length === 0) {
      this.setState(
        {
          hoverOnModal: !this.state.hoverOnModal,
        },
        () => {
          window.removeEventListener('focus', this.handleFocusBack);
        },
      );
    }
  };

  handleCancelEvent = () => {
    this.setState({ hoverOnModal: !this.state.hoverOnModal }, () => {
      window.addEventListener('focus', this.handleFocusBack);
    });
  };

  render() {
    const {
      visible,
      onCancel,
      onDownload,
      bulkUploadProcessing: { uploadingExcel },
    } = this.props;
    const { pickingExcel, hoverOnModal } = this.state;

    return (
      <Modal
        visible={visible}
        className={css.importExcelModal}
        onCancel={onCancel}
        closable={false}
        maskClosable
        footer={null}
        centered
        style={{ top: 75 }}
        width={750}
      >
        <div id={UPLOAD_SPREADSHEET_MODAL_ID}>
          <Row className={css.headerInfo}>
            <p>{I18n.t('v2.homepage.uploadOrder.modal.heading')}</p>
          </Row>
          <div>
            <SpreadSheetUploader
              loading={uploadingExcel}
              picking={pickingExcel}
              handleExcelUpload={this.onUploadExcel}
              hoverOnModal={hoverOnModal}
              onClickModal={this.onClickModal}
              handleCancelEvent={this.handleCancelEvent}
            />
          </div>
          <Row className={css.footer} type="flex">
            <Col className={css.downloadSample}>
              <span>{I18n.t('v2.homepage.uploadOrder.modal.toBegin')}</span>
              <span
                role="button"
                tabIndex="0"
                onKeyPress={null}
                onClick={onDownload}
                className={css.downloadText}
              >
                {I18n.t('v2.homepage.uploadOrder.modal.downloadTemplate')}
              </span>
            </Col>
          </Row>
        </div>
      </Modal>
    );
  }
}

UploadSpreadSheetModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
  processBulkUploadData: PropTypes.func.isRequired,
  bulkUploadProcessing: PropTypes.shape({}).isRequired,
  userInfo: PropTypes.shape({}).isRequired,
};

UploadSpreadSheetModal.defaultProps = {
  visible: false,
};

export default UploadSpreadSheetModal;
